import { render, staticRenderFns } from "./RegulatoryUpdatePersonalData.vue?vue&type=template&id=1e82539b&scoped=true&"
import script from "./RegulatoryUpdatePersonalData.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdatePersonalData.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatoryUpdatePersonalData.vue?vue&type=style&index=0&id=1e82539b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e82539b",
  null
  
)

export default component.exports